// @ts-strict-ignore
import React from 'react';
import NumberInputWithSymbol from '~/components/inputs/NumberInputWithSymbol';

export interface AggregationNumberInputProps {
  minValue: number;
  maxValue: number;
  value: React.ComponentProps<typeof NumberInputWithSymbol>['value'];
  onHandleValueChange: (value: number) => void;
  /** Number of decimal places allowed. 0 = integer only (default). */
  decimalScale?: number;
  className?: string;
}

const AggregationNumberInput = ({
  minValue,
  maxValue,
  value,
  onHandleValueChange,
  decimalScale = 0,
  className,
}: AggregationNumberInputProps) => (
  <span className={className} data-aggregation-number-input>
    <NumberInputWithSymbol
      type="number"
      minValue={minValue}
      maxValue={maxValue}
      value={value}
      decimalScale={decimalScale}
      onHandleValueChange={onHandleValueChange}
    />
  </span>
);

export default AggregationNumberInput;
